/*    
<summary>
    This functional common component provides modal popup that shows delete confirmation message (i.e. are you sure want to delete).    
    Developer:Mohammad Saquib Khan, Created Date:04-April-2024
</summary>
<returns>Returns JSX</returns>
*/
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LoaderButton from '../../../shared-components/button/loader-button'; // Custom loader button component
import { Field, Form, Formik } from 'formik';
import Label from '../../../shared-components/label/label';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import { observer } from 'mobx-react';
 
interface Props {
    modalSubmit: (details:any) => void; // Function to handle modal submission
    modalClosed: () => void;
    isLoading: boolean;
    title: string;
    message?: string;
    isReservationSales: boolean; // Optional prop to indicate if it's a reservation sales modal
}
 
const DeleteSMRCancelForm: React.FC<Props> = props => {
    return (
        <Modal size="sm" show={true} centered dialogClassName={` ${props.isReservationSales ? '' : 'delete_popup'}`}>
            <Modal.Header>
                <Modal.Title><FormattedMessage id={props.title} />
                    <button onClick={props.modalClosed} disabled={props.isLoading} className="Crossicons" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                    </button>
                </Modal.Title>
            </Modal.Header>
            <>
                <Formik
                    initialValues={{ CancellationType: "1" }} // Initial form values
                    enableReinitialize // Reinitialize form values when props change
                    onSubmit={props.modalSubmit} // Form submission handler
                >
                    {({ isSubmitting }) => (
                       
                        <Form className="user-form">
                            {" "}
                            {/* Formik form */}
                            {props.isLoading && <FormLoader loading={props.isLoading} />}{" "}
                            {/* Show loader if loading */}
                           
                            <Modal.Body >
                                {
                                    props.isReservationSales ? (
                                        <div>
                                            <Label className="label-style" label="cancellation_type" />{" "}
                                            {/* Label for cancellation type */}
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Field
                                                        className="form-check-input" // Radio button for "By Call"
                                                        name="CancellationType"
                                                        type="radio"
                                                        value="1"
                                                        id="by_call"
                                                    />
                                                    <label className="form-check-label" htmlFor="by_call">
                                                        <FormattedMessage id="by_call" />{" "}
                                                        {/* Label for "By Call" */}
                                                    </label>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Field
                                                        className="form-check-input" // Radio button for "By Visit"
                                                        name="CancellationType"
                                                        type="radio"
                                                        value="2"
                                                        id="by_visit"
                                                    />
                                                    <label className="form-check-label" htmlFor="by_visit">
                                                        <FormattedMessage id="by_visit" />{" "}
                                                        {/* Label for "By Visit" */}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
 
                                    ) : (
                                        <div className="bootbox-body">
                                            <FormattedMessage id={props.message} />
                                            {/* Display the message passed as a prop */}
                                        </div>
                                    )
                                }
                            </Modal.Body>
                            <div className="modal-footer center-content">
                                <Button
                                    variant="outline-danger" // Close button
                                    type="button"
                                    onClick={props.modalClosed} // Close modal on button click
                                    disabled={props.isLoading} // Disable button if loading
                                >
                                    <i className="bi bi-x-lg me-1"></i> {/* Close icon */}
                                    <FormattedMessage id="close" /> {/* Close button text */}
                                </Button>
 
                                <LoaderButton
                                    type="submit" // Submit button
                                    iconName="bi-check-lg" // Submit icon
                                    isLoading={props.isLoading} // Show loader if loading
                                    text={"button_save"} // Submit button text
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </>
        </Modal>
    );
};
 
export default observer(DeleteSMRCancelForm);